import { Trash2, Loader2, Zap } from "lucide-react";
import { Checkbox } from "@/components/ui/checkbox";
import { TurnstileWidget } from "@/components/TurnstileWidget";

export const InputPanel = ({ mode, setMode, text, setText, urlCount, excludeDupes, setExcludeDupes, excludeSameDomain, setExcludeSameDomain, onCheck, loading, showTurnstile, turnstileToken, onTurnstileToken, turnstileKey }) => {
  const overLimit = urlCount > 1000;
  const needsTurnstile = showTurnstile && !turnstileToken;

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 w-full max-w-4xl mx-auto fade-up fade-up-2" data-testid="input-panel">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center space-x-2 bg-gray-100 p-1 rounded-full w-fit" role="tablist">
          {["single", "bulk"].map((m) => (
            <button
              key={m}
              role="tab"
              data-testid={`mode-tab-${m}`}
              aria-selected={mode === m}
              onClick={() => setMode(m)}
              className={`px-5 py-1.5 text-sm font-medium rounded-full transition-colors duration-200 capitalize ${
                mode === m
                  ? "bg-white text-[#C0392B] border border-[#C0392B] shadow-sm"
                  : "text-gray-600 hover:text-gray-900 border border-transparent"
              }`}
            >
              {m}
            </button>
          ))}
        </div>
        <button
          data-testid="clear-input-btn"
          onClick={() => setText("")}
          title="Clear all input"
          className="text-gray-400 hover:text-red-500 transition-colors p-2 rounded-lg hover:bg-red-50"
        >
          <Trash2 size={18} />
        </button>
      </div>

      <textarea
        data-testid="domain-input"
        value={text}
        onChange={(e) => setText(e.target.value)}
        placeholder={mode === "single" ? "example.com" : "example.com\nanother-site.org\nmydomain.net\n… one domain per line (up to 1000)"}
        className="w-full h-48 p-4 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#C0392B]/20 focus:border-[#C0392B] outline-none resize-none text-sm bg-gray-50/50 transition-colors"
        style={{ fontFamily: "'IBM Plex Mono', monospace" }}
      />

      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mt-3 gap-3">
        <span
          data-testid="url-counter"
          aria-live="polite"
          className={`text-sm font-semibold ${overLimit ? "text-red-600" : "text-gray-500"}`}
        >
          URLS: {urlCount}{overLimit && " (max 1000)"}
        </span>
        <div className="flex flex-wrap items-center gap-6">
          <label className="flex items-center space-x-2 text-sm text-gray-600 cursor-pointer" data-testid="exclude-duplicates-label">
            <Checkbox
              data-testid="exclude-duplicates-checkbox"
              checked={excludeDupes}
              onCheckedChange={(v) => setExcludeDupes(!!v)}
              className="data-[state=checked]:bg-[#C0392B] data-[state=checked]:border-[#C0392B]"
            />
            <span>Exclude duplicate URLs</span>
          </label>
          <label className="flex items-center space-x-2 text-sm text-gray-600 cursor-pointer" data-testid="exclude-same-domain-label">
            <Checkbox
              data-testid="exclude-same-domain-checkbox"
              checked={excludeSameDomain}
              onCheckedChange={(v) => setExcludeSameDomain(!!v)}
              className="data-[state=checked]:bg-[#C0392B] data-[state=checked]:border-[#C0392B]"
            />
            <span>Exclude same domain</span>
          </label>
        </div>
      </div>

      {showTurnstile && (
        <div className="mt-5 flex justify-center" data-testid="turnstile-container">
          <TurnstileWidget key={turnstileKey} onToken={onTurnstileToken} />
        </div>
      )}

      <button
        data-testid="check-dapa-btn"
        onClick={onCheck}
        disabled={loading || urlCount === 0 || overLimit || needsTurnstile}
        className="mt-8 w-full sm:w-auto px-12 py-4 bg-[#C0392B] hover:bg-[#A93226] disabled:opacity-50 disabled:cursor-not-allowed text-white rounded-full font-bold text-lg shadow-[0_4px_14px_0_rgba(192,57,43,0.39)] transition-colors active:scale-95 flex items-center justify-center gap-2 mx-auto"
      >
        {loading ? <Loader2 size={20} className="animate-spin" /> : <Zap size={20} />}
        {loading ? "Scanning…" : "Check DA PA"}
      </button>
    </div>
  );
};
